import * as Actions from "./actions";
import { initialState } from "../store/initialState";

export const OpusesReducer = (state = initialState.opuses, action) => {
  switch (action.type) {
    case Actions.DELETE_OPUS:
      return {
        ...state,
        list: action.payload,
      };
    case Actions.FETCH_MY_OPUSES:
      return {
        ...state,
        list: action.payload,
      };
    case Actions.FETCH_SELECTED_OPUS:
      return {
        ...state,
        ...action.payload,
      };
    case Actions.INIT_MY_OPUSES:
      return {
        ...initialState.opuses,
      };
    case Actions.SLECTED_OPUS:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
};
